export default "__VITE_ASSET__CPUX5qZO__"